import { DEPLOYMENT_ENV as ENV } from '@futrli/shared-services';

export const API_URL = window.__env__.API_URL;
export const SAGEID_ENVIRONMENT = window.__env__.SAGEID_ENVIRONMENT;
export const SAGEID_CLIENT_ID = window.__env__.SAGEID_CLIENT_ID;
export const INTEGRATIONS_API_URL = window.__env__.INTEGRATIONS_API_URL;
export const AWS_IDENTITY_POOL_ID = window.__env__.AWS_IDENTITY_POOL_ID;
export const AWS_REGION = window.__env__.AWS_REGION || 'eu-west-1';
export const AWS_SERVICE = window.__env__.AWS_SERVICE || 'execute-api';
export const AWS_USER_POOL_ID = window.__env__.AWS_USER_POOL_ID;
export const AWS_USER_POOL_WEB_CLIENT_ID = window.__env__.AWS_USER_POOL_WEB_CLIENT_ID;
export const DEPLOYMENT_ENV = window.__env__.DEPLOYMENT_ENV || ENV.DEVELOPMENT;
export const DP2_EVENT_WEBSOCKET_URI = window.__env__.DP2_EVENT_WEBSOCKET_URI;
export const FLOW_API_URL = window.__env__.FLOW_API_URL;
export const FLOW_API_ECS_URL = window.__env__.FLOW_API_ECS_URL;
export const HOST = window.__env__.HOST;
export const LAUNCH_DARKLY_ID = window.__env__.LAUNCH_DARKLY_ID;
export const PREDICT_API_URL = window.__env__.PREDICT_API_URL;
export const PULSE_API_URL = window.__env__.PULSE_API_URL;
export const SEGMENT_ID = window.__env__.SEGMENT_ID;
export const PENDO_API_KEY = window.__env__.PENDO_API_KEY;
export const BIRDIE_TEAM_ID = window.__env__.BIRDIE_TEAM_ID;
export const INTERCOM_APP_ID = window.__env__.INTERCOM_APP_ID;
export const SENTRY_DSN_URL = window.__env__.SENTRY_DSN_URL;
export const SESSION_DURATION_MS = parseInt(window.__env__.SESSION_DURATION_MS || '43200000', 10);
export const STRIPE_API_KEY = window.__env__.STRIPE_API_KEY;
export const FLOW_TRIAL_PERIOD_HOURS = window.__env__.FLOW_TRIAL_PERIOD_HOURS;
export const PREDICT_TRIAL_PERIOD_HOURS = window.__env__.PREDICT_TRIAL_PERIOD_HOURS;
